const ChevronLeft = ({ ...props }) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#F6F5F4" />
      <path
        d="m18.477 20.921.159-.159a.27.27 0 0 0 0-.38l-4.382-4.38 4.382-4.383a.27.27 0 0 0 0-.38l-.16-.16a.27.27 0 0 0-.38 0l-4.732 4.73a.27.27 0 0 0 0 .38l4.732 4.73a.267.267 0 0 0 .38.002Z"
        fill="#464544"
      />
   </svg>
  )
}

export default ChevronLeft
